interface LogoProps {
  className?: string;
}

export function CautiousLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M25,3.5c-6.6,0-12.1,5.3-12.1,12v5.5c-2.2,0-4,1.7-4,3.9v17.6c0,2.2,1.7,4,3.9,4h24.3c2.2,0,4-1.7,4-3.9v-17.6c0-2.2-1.7-4-3.9-4h-.2v-5.4c0-6.7-5.3-12.1-12-12.1h-.1M38.4,25v17.5c0,.7-.5,1.3-1.2,1.3H12.9c-.7,0-1.3-.5-1.3-1.2v-17.6c0-.7.5-1.3,1.2-1.3h24.3c.7,0,1.3.5,1.3,1.2h0M15.6,21v-5.4c0-5.2,4.2-9.4,9.4-9.4,5.2,0,9.4,4.2,9.4,9.4h0v5.4H15.6Z" 
      />
      <path 
        fill="currentColor" 
        d="M25,27.7c-2.2,0-4,1.7-4,3.9h0c0,1.9,1.1,3.4,2.7,3.9v3c0,.7.5,1.3,1.2,1.3h.1c.7,0,1.3-.5,1.3-1.2v-3.1c1.6-.5,2.7-2.1,2.7-3.8,0-2.2-1.7-4-3.9-4h-.1M25,33.1c-.7,0-1.3-.6-1.3-1.3s.6-1.3,1.3-1.3,1.3.6,1.3,1.3-.6,1.3-1.3,1.3" 
      />
    </svg>
  );
}